import {initWebComponent} from "@/helpers/web-component-helper";
import {addLayer, getBookmarkPresentations, getBookmarkPresentationsByID} from "@/helpers/ol/ol-layer-helper";
import {addLayerActive} from "@/helpers/ol/ol-layer-active-helper";
import {getBranchItemByBookmarkPresentationID} from "@/helpers/tree-helper";
import {getTemporaryLayerByIndex} from "@/helpers/layer/temporary/temporary-layer-helper";
import {getActiveSession, getDefaultSession} from "@/helpers/user-session-helper";
import {applyFilter, setActiveFilter} from "@/helpers/filter/filter-helper";
import {setDefaultViewUrlParamObject} from "@/helpers/ol/ol-map-helper";
import {getViewProjectionName} from "@/helpers/ol/ol-projection-helper";
import {showElementsByDataAttribute, showElementsBySelector} from "@/helpers/element-helper";
import {hasLayerDomainList} from "@/helpers/layer/overview/layer-overview-domain-list-helper.js";
// import {initLayerMenuGroupItemClick} from "@/helpers/layer-menu-helper";

const template = document.createElement('template');
let previousChecked = ''
let removeChecked = ''

export class LayerMenuGroupItemComponent extends HTMLElement{
    constructor(){
        super();

        let label = this.getAttribute('data-label')
        let checked = this.getAttribute('data-checked')
        let isRoot = this.getAttribute('data-root')
        let isCheckbox = this.getAttribute('data-checkbox')
        let id = this.getAttribute('data-id')
        let parentId = this.getAttribute('data-parent-id')
        const type =  this.getAttribute('data-type')
        const key = this.getAttribute('data-key')
        const depth = this.getAttribute('data-depth')
        const merged = this.getAttribute('data-merged')
        const bookmarkPresentationID = this.getAttribute('data-bookmark-presentation-id')

        let checkedValue = ''
        let branch

        const userSession = getActiveSession()

        let userSessionBookmarkPresentation = undefined
        if(bookmarkPresentationID) {
            if(String(bookmarkPresentationID).includes('temporary-')) {
                const temporaryLayer = getTemporaryLayerByIndex(bookmarkPresentationID)
                branch = {
                    filter_forms: [],
                    mutation_forms: []
                }
                label = temporaryLayer.Name
                id = bookmarkPresentationID
            } else {
                branch = getBranchItemByBookmarkPresentationID(bookmarkPresentationID)
                label = branch.label
                id = branch.ID
            }

            // checked = "1"
            isCheckbox = "1"
            isRoot = true
            if(checked === "1") {
                checkedValue = 'checked="checked"'
            }
        } else {
            branch = window.branch[depth][key]
            if(window.urlParamsObject.presentatie === label) {
                if(window.urlParamsObject.waarde) {
                    if (window.urlParamsObject.waarde.includes(',')) {
                        setDefaultViewUrlParamObject('x')
                        let check = function () {
                            const timeout = setTimeout(function () {
                                if (window.filters.length === 0)
                                    check();
                                else {
                                    clearTimeout(timeout)
                                    setActiveFilter(id)
                                    applyFilter()
                                }
                            }, 500);
                        };
                        check();

                    } else {

                        if(window.urlParamsObject.bookmarkpresentatieids && !window.urlParamsObject.bookmarkpresentatieids.split(',').includes(id)) {
                            addLayer(id, id)
                            addLayerActive(id, label, true)
                        } else if(!window.urlParamsObject.bookmarkpresentatieids && !window.urlParamsObject.aan) {
                            addLayer(id, id)
                            addLayerActive(id, label, true)
                        }
                    }
                }
            }

            const parentItem = getBranchItemByBookmarkPresentationID(id)
            if(parentItem && parentItem.parent && parentItem.parent.Type === 2 && !parentItem.parent.Checked && checked !== "1") {
                checked = ''
            }


            if(window.urlParamsObject.aan || window.urlParamsObject.bookmarkpresentatieids) {
                if(!bookmarkPresentationID) {
                    branch = getBranchItemByBookmarkPresentationID(this.getAttribute('data-id'))
                }
                // if(branch.parent.Type !== 2) {
                    checked = ""

                    let presentationNames
                    if(window.urlParamsObject.aan) {
                        presentationNames = window.urlParamsObject.aan.split(',')
                    } else {
                        presentationNames = window.urlParamsObject.bookmarkpresentatieids.split(',')
                    }

                    presentationNames.map(presentationName => {
                        if(parseInt(presentationName)) {
                            if(parseInt(presentationName) === branch.ID) {
                                checked = "1"
                            }
                        } else {
                            if(presentationName === label) {
                                checked = "1"
                            }
                        }
                    })
                // }
            }


            if(userSession) {
                checked = ""
                userSessionBookmarkPresentation  = userSession.user_session_bookmark_presentations.find(userSessionPresentation => userSessionPresentation.BookmarkPresentationID === parseInt(id))

                if(userSessionBookmarkPresentation) {
                    if (userSessionBookmarkPresentation.Checked) {
                        addLayerActive(id, label, true)
                        addLayer(id)
                        checkedValue = 'checked="checked"'
                        checked = "1"
                    } else {
                        addLayerActive(id, label, false)
                        checkedValue = ''
                    }
                }
            } else {

                if (checked === "1") {

                    checkedValue = 'checked="checked"'
                    addLayer(id)
                    addLayerActive(id, label, true)
                }
            }
        }

        if(branch && branch.mutation_forms && branch.mutation_forms.length > 0) {
            showElementsBySelector('layer-info-mutation-button')
            showElementsByDataAttribute('data-id', '4', 'data-step', '4');
        }

        let rootClass = 'accordion-group-item'
        if(isRoot) {
            rootClass = 'pl-0 pr-0 mb-1'
        }

        let innerHTML = `
            <div class="card-body ` + rootClass + `">
                <div class="form-group">`

        if(isCheckbox === "1") {
            innerHTML += `<label class="custom-control custom-checkbox" title="${label}">
                            <input type="checkbox" data-presentation-id="${branch.presentationID}" value="` + id + `" data-label="` + label + `" class="custom-control-input checkbox-group-item" ` + checkedValue + `>
                            <span class="custom-control-label">${label} 
                <div class="label-sk-wave"></div>
                </span>`
        } else {
            innerHTML += `<label class="custom-control custom-radio" title="${label}">
                <input name="custom-radio-` + parentId + `" data-presentation-id="${branch.presentationID}" data-label="` + label + `" type="radio" value="` + id + `" class="custom-control-input checkbox-group-item"" ` + checkedValue + `>
                    <span class="custom-control-label">` + label + `</span>`
        }

        innerHTML += `<div class="layer-menu-button mr-1">`

        if(bookmarkPresentationID) {
            innerHTML += `<layer-menu-active-item-remove  data-id="` + id + `"></layer-menu-active-item-remove>`
        }

        innerHTML += `<layer-menu-button-zoom-scale class="d-none" data-id="${id}"></layer-menu-button-zoom-scale>`

        innerHTML += `<layer-menu-button-check class="d-none"></layer-menu-button-check>`

        let hiddenClass = 'd-none'
        if(checked === "1") {
            hiddenClass = ''
        }

        innerHTML += `<layer-menu-active-item-zoom class="${hiddenClass}" data-id="${id}"></layer-menu-active-item-zoom><layer-menu-button-info class="${hiddenClass}" data-id="${id}"></layer-menu-button-info>`

        if(branch.is3D && getViewProjectionName() === 'EPSG:3857') {
            innerHTML += '<layer-menu-button-3d  data-id="' + id + '"></layer-menu-button-3d>'
        }
        if(branch.filter_forms && branch.filter_forms.length > 0) {
            const filterForm = branch.filter_forms[0]
            innerHTML += '<layer-menu-button-filter  data-bookmark-presentation-id="' + id + '" data-presentation-id="' + filterForm.PresentationID + '" data-form-id="' + filterForm.FormID + '"></layer-menu-button-filter>'
        }

        // Only WFS can draw
        if(branch.mutation_forms && branch.mutation_forms.length > 0 && branch.serviceType === 'WFS') {
            const mutationForm = branch.mutation_forms[0]

            let mutationForms = branch.mutation_forms.filter(form => form.hasGeometry === true || form.hasGeometry === undefined)

            if(mutationForms.length > 0) {
                if (!bookmarkPresentationID) {
                    branch.mutation_forms.map(mutationForm => {
                        mutationForm.DomainID = branch.domainID
                        mutationForm.BookmarkPresentationID = id
                    })
                    window.mutationForms.push(...branch.mutation_forms)
                }

                if (branch.userRights.includes(5)) {
                    innerHTML += '<layer-menu-button-mutation data-domain-id="' + branch.domainID + '" data-bookmark-presentation-id="' + id + '" data-presentation-id="' + mutationForm.PresentationID + '" data-form-id="' + mutationForm.FormID + '"></layer-menu-button-mutation>'
                }
            }
        }

            innerHTML += '</div>'

            // if(checked === "1" || bookmarkPresentationID) {
            //     innerHTML += '</div></div></div>'
            // }

            innerHTML += `</label>`


        innerHTML += `</div>
            </div>
        `;

        template.innerHTML = innerHTML

        initWebComponent(this, template)

        // if(bookmarkPresentationID) {
        //     initLayerMenuGroupItemClick(this)
        // }
    }
}
